export function loadGoogleMapsAPI() {
  return new Promise((resolve, reject) => {
    // Already loaded
    if (window.google && window.google.maps) {
      resolve(window.google);
      return;
    }
    
    // Set callback
    window.initGoogleMaps = () => {
      delete window.initGoogleMaps;
      resolve(window.google);
    };
    
    // Load script dynamically
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'AIzaSyBhiiu5qHQcZEr-nHzqMe3Ga5NyXWCFZKI'; // Fallback for testing
    
    if (!apiKey) {
      reject(new Error('Google Maps API key not found. Please add VITE_GOOGLE_MAPS_API_KEY to .env'));
      return;
    }
    
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initGoogleMaps`;
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error('Failed to load Google Maps script'));
    
    document.head.appendChild(script);
    
    // Timeout after 15 seconds
    setTimeout(() => {
      reject(new Error('Google Maps API failed to load. Please check your API key.'));
    }, 15000);
  });
}
